// extracted by mini-css-extract-plugin
export default {"wrap":"f3eced8a879b","inspect":"d46050c8419b","pane":"d0ddedca6c17","instructionsHeading":"b9147c7ed9af","orFollowInstructions":"bf7d730dac10","instructions":"dde64954223a"};